<template>
  <Modal :toggle="toggle" @close="$emit('close')">
    <div class="modal-confirm">
      <div class="title">请确认支付是否已完成</div>
      <div class="btn-block">
        <div class="btn-wrapper">
          <div class="cancel" @click="$emit('cancel')">再看看</div>
        </div>
        <div class="btn-wrapper">
          <div class="complete" @click="$emit('complete')">支付完成</div>
        </div>
      </div>
      <div class="service">
        <p>温馨提醒</p>
        <p>
          支付遇到问题，点击
          <span class="btn-contact" @click="$emit('service')">联系客服</span>
        </p>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import Modal from '@/components/Modal';
@Component({
  components: {
    Modal,
  },
})
export default class ModalConfirm extends Vue {
  @Prop(Boolean) toggle!: boolean;
}
</script>

<style lang="scss" scoped>
$main-btn-color: linear-gradient(259deg, #fdc538, #fd9246);
$main-btn-hover-color: linear-gradient(249deg, #fdd574, #fdb27d);
$title-color: #3c3c52;
$content-color: #9d9db5;
$light-color: #5155f4;
$cancel-btn-color: #6a6a89;
.modal-confirm {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 630px;
  height: 508px;
  padding: 64px 0px 80px;
  background-color: #ffffff;
  border-radius: 24px;
  .title {
    position: relative;
    color: $title-color;
    font-weight: 600;
    font-weight: 500;
    font-size: 42px;
    &::before {
      position: absolute;
      bottom: -16px;
      left: 50%;
      display: block;
      width: 54px;
      height: 8px;
      background: #c1bece;
      border-radius: 4px;
      transform: translate(-50%, 0);
      content: '';
    }
  }
  .btn-block {
    display: flex;
    margin-top: 96px;
    .btn-wrapper {
      width: 246px;
      height: 95px;
      color: #fff;
      border-radius: 8px;
      user-select: none;
    }
    .cancel,
    .complete {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      font-weight: 500;
      font-size: 30px;
      border-radius: 8px;
    }
    .cancel {
      color: #6a6a89;
      background: #f1f2f8;
      &:active {
        color: #9696ac;
        background: #f5f5fa;
      }
    }
    .complete {
      margin-left: 24px;
      color: #fff;
      background: #ea632f;
      &:active {
        background: #f4b197;
      }
    }
  }
  .service {
    width: 502px;
    margin-top: 24px;
    color: $content-color;
    font-weight: normal;
    font-size: 30px;
    line-height: 1.5;
  }
  .btn-contact {
    color: #ea632f;
  }
}
</style>